import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '../../../core/http-api.service';
import { ReferralsImport, ReferralsImportSource, ReferralsLastImport } from './import.interfaces';

@Injectable({ providedIn: 'root' })
export class ReferralsImportHttpService {
  constructor(private httpApiService: HttpApiService) {}

  public importFile(data: {
    file: File;
    source: ReferralsImportSource;
  }): Observable<ReferralsImport> {
    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => formData.append(key, <string>value));

    return this.httpApiService
      .post('/imports', null, formData)
      .pipe(map(response => response.import));
  }

  public deleteImport(source: ReferralsImportSource): Observable<void> {
    return this.httpApiService.delete('/imports', { source });
  }

  public loadLatestImport(): Observable<ReferralsLastImport[]> {
    return this.httpApiService.get('/imports/latest').pipe(map(response => response.imports));
  }

  public initializeGoogleImport(): Observable<{ authUrl: string }> {
    return this.httpApiService.get('/oauth/authenticate');
  }
}
